import React from "react";
import { Label } from "semantic-ui-react";
import { SemanticCOLORS } from "semantic-ui-react/dist/commonjs/generic";

type SubmissionStatusLabelProps = {
  status: string;
};

const SubmissionStatusLabel = ({ status }: SubmissionStatusLabelProps) => {
  const getStatusColor = (): SemanticCOLORS => {
    if (status === "awaiting-response") return "brown";
    if (status === "accepted") return "orange";
    if (status === "activated") return "blue";
    if (status === "rejected") return "grey";
    if (status === "cancelled") return "grey";
    if (status === "provisioned") return "green";
    if (status === "pov") return "black";
    if (status === "date-change-requested") return "teal";
    return "black";
  };
  const getStatusLabel = (): string => {
    if (status === "awaiting-response") return "Awaiting Response";
    if (status === "accepted") return "Accepted";
    if (status === "activated") return "Activated";
    if (status === "rejected") return "Rejected";
    if (status === "cancelled") return "Cancelled";
    if (status === "provisioned") return "Provisioned";
    if (status === "pov") return "Pre-Order Validation";
    if (status === "date-change-requested") return "Date Change Request";
    return "Unknown";
  };
  return <Label color={getStatusColor()}>{getStatusLabel()}</Label>;
};

export default SubmissionStatusLabel;
